/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface DanceActivityFeedItem
 */
export interface DanceActivityFeedItem {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityFeedItem
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityFeedItem
     */
    danceId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceActivityFeedItem
     */
    danceName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityFeedItem
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceActivityFeedItem
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DanceActivityFeedItem
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof DanceActivityFeedItem
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the DanceActivityFeedItem interface.
 */
export function instanceOfDanceActivityFeedItem(value: object): value is DanceActivityFeedItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('danceId' in value) || value['danceId'] === undefined) return false;
    if (!('danceName' in value) || value['danceName'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function DanceActivityFeedItemFromJSON(json: any): DanceActivityFeedItem {
    return DanceActivityFeedItemFromJSONTyped(json, false);
}

export function DanceActivityFeedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DanceActivityFeedItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'danceId': ApiUserTasksGetPageParameterFromJSON(json['danceId']),
        'danceName': json['danceName'],
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'type': json['type'],
        'text': json['text'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function DanceActivityFeedItemToJSON(json: any): DanceActivityFeedItem {
    return DanceActivityFeedItemToJSONTyped(json, false);
}

export function DanceActivityFeedItemToJSONTyped(value?: DanceActivityFeedItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'danceId': ApiUserTasksGetPageParameterToJSON(value['danceId']),
        'danceName': value['danceName'],
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'type': value['type'],
        'text': value['text'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

